import { getQueryString } from './commons';
import axios from './index';

const API_URL = 'api/v1/groups';

export const getGroupsAPI = async (query) => {
    const queryString = getQueryString(query, window.location.search);
    return axios.get(queryString ? `${API_URL}/?${queryString}` : `${API_URL}`);
};
export const createGroupAPI = async (groupData) => axios.post(API_URL, groupData);
export const updateGroupAPI = async (groupId, groupData) => axios.put(`${API_URL}/${groupId}`, groupData);
export const deleteGroupAPI = async (groupId) => axios.delete(`${API_URL}/${groupId}`);

export const editGroupAPI = async (groupId, groupData) => axios.put(`${API_URL}/${groupId}/editGroup`, groupData);

export const getPractitionersInGroupAPI = async (groupId, query) => {
    const queryString = getQueryString(query, window.location.search);
    return axios.get(queryString ? `${API_URL}/practitionersInGroup/${groupId}/?${queryString}` : `${API_URL}/practitionersInGroup/${groupId}`);
}

export const addPractitionersAPI = async (groupId, practitioners) => axios.post(`${API_URL}/${groupId}/practitioners/add`, practitioners);
export const removePractitionersAPI = async (groupId, practitionerId) => axios.delete(`${API_URL}/${groupId}/practitioners/${practitionerId}/remove`);


export const removeAllPractitionersAPI = async (groupId, query) => {
    const queryString = getQueryString(query, window.location.search);
    return axios.delete(queryString ? `${API_URL}/deleteAllPractitioners/${groupId}/?${queryString}` : `${API_URL}/deleteAllPractitioners/${groupId}`);
}

export const getPatientsInGroupAPI = async (groupId, query) => {
    const queryString = getQueryString(query, window.location.search);
    return axios.get(queryString ? `${API_URL}/patientsInGroup/${groupId}/?${queryString}` : `${API_URL}/patientsInGroup/${groupId}`);
}

export const addPatientsAPI = async (groupId, patients) => axios.post(`${API_URL}/${groupId}/patients/add`, patients);
export const removePatientAPI = async (groupId, patientId) => axios.delete(`${API_URL}/${groupId}/patients/${patientId}/remove`);


export const removeAllPatientsAPI = async (groupId, query) => {
    const queryString = getQueryString(query, window.location.search);
    return axios.delete(queryString ? `${API_URL}/deleteAllPatients/${groupId}/?${queryString}` : `${API_URL}/deleteAllPatients/${groupId}`);
}

export const addPatientToPractitionerAPI = async (groupId, patientId, practitionerId) => axios.post(`${API_URL}/${groupId}/practitioners/${practitionerId}/addPatient/${patientId}`);
//export const updatePractitionerPatientAssignmentsApi = async (updatedRelations) => axios.put(`${API_URL}/patientsPractitioners/update`);
export const updatePractitionerPatientAssignmentsApi = async (practitionerId, groupId, requestBody) => {

    const url = `${API_URL}/${groupId}/patientsPractitioners/${practitionerId}/update`;


    const response = await axios.post(url, requestBody); 

    return response.data;
};

export const reasignPatientsApi = async (groupId ,oldPractitioner, newPractitioner, patientIds) => {
    const url = `${API_URL}/${groupId}/practitioners/reassign`;

    const requestBody = {
        groupId: groupId, 
        oldPractitionerId: oldPractitioner,
        newPractitionerId: newPractitioner, 
        patientIdsToReassign: patientIds || [], 
    };

    const response = await axios.post(url, requestBody);

    return response.data;
};
